import { render } from "./ControlTheSizeOfTheSpace.vue?vue&type=template&id=300d0bc8"
import script from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=ts"
export * from "./ControlTheSizeOfTheSpace.vue?vue&type=script&lang=ts"

import "./ControlTheSizeOfTheSpace.vue?vue&type=style&index=0&id=300d0bc8&lang=scss"
script.render = render

export default script